module.exports = __webpack_public_path__ + "images/category_lp/smartphone/assessment_achievements/6_193706f4d8c112c5ba78409c94183df4.jpg";